import b from 'b_';
import cx from 'classnames';
import React from 'react';

import { BUTTON_SIZES, BUTTON_THEMES, BUTTON_VIEWS } from '../constants';

import './old-button.scss';

export interface Props
    extends React.DetailedHTMLProps<React.ButtonHTMLAttributes<HTMLButtonElement>, HTMLButtonElement> {
    children?: React.ReactNode;
    disabled?: boolean;
    glowing?: boolean;
    hasShadow?: boolean;
    hidden?: boolean;
    mix?: string | string[];
    size?: BUTTON_SIZES;
    theme?: BUTTON_THEMES;
    view?: BUTTON_VIEWS;
    onClick?: (e: React.MouseEvent) => void;
    ref?: (ref: React.ReactInstance | null) => void;
}

interface State {
    focused: boolean;
}

class Button extends React.Component<Props, State> {
    static defaultProps = {
        hidden: false,
        size: BUTTON_SIZES.M,
        theme: BUTTON_THEMES.NORMAL,
    };

    state: State = {
        focused: false,
    };

    onFocus = () => {
        this.setState({ focused: true });
    };

    onBlur = () => {
        this.setState({ focused: false });
    };

    render() {
        const { disabled, hidden, mix, size, theme, view, glowing, hasShadow, ...nodeProps } = this.props;

        const className = b('old-button', {
            disabled,
            focused: this.state.focused,
            glowing,
            shadow: hasShadow && !disabled,
            hidden,
            size,
            theme,
            view,
        });

        return (
            <button
                {...nodeProps}
                className={cx(className, mix)}
                disabled={disabled}
                onBlur={this.onBlur}
                onFocus={this.onFocus}
            >
                {this.props.children}
            </button>
        );
    }
}

export default Button;

// zzzorgo update-dev and vlada
